import * as React from 'react';
import classnames from 'classnames';
import { Heading } from '@grandvisionhq/elements';

const BrandListGroup = ({ title , children , className  })=>{
     return React.createElement("li", {
        className: classnames('brand-list-group', className)
    }, /*#__PURE__*/ React.createElement(Heading, {
        variant: "subheading1",
        className: classnames('brand-list-group__title', {
            'brand-list-group__title--empty': !(title === null || title === void 0 ? void 0 : title.length)
        })
    }, title), children);
};
var BrandListGroup$1 = BrandListGroup;

export { BrandListGroup$1 as default };
//# sourceMappingURL=BrandListGroup.js.map
